<template>
	<div class="container-fluid pt-3 pt-md-5">
		<div class="row">
			<div class="col-lg-2 col-md-3">
				<NavbarMembership />
			</div>
			<div class="col-lg-10 col-md-9 px-0 px-md-3">
				<div v-if="!loading" class="col-12">
					<div v-if="user_role == 'superadmin'" class="row no-wrap">
						<div class="col-xl-20-percent col-md-6 mb-4">
							<div class="card border-left-warning shadow h-100 py-2">
								<div class="card-body">
									<div class="row no-gutters align-items-center">
										<div class="col mr-2">
											<div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
												Socios nuevos (Mes Actual)
											</div>
											<div class="h5 mb-0 font-weight-bold text-gray-800">
												{{ numEnabledMembers_current_month }}
											</div>
										</div>
										<div class="col-auto">
											<i class="fa-duotone fa-user-plus fa-2x text-gray-300"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-20-percent col-md-6 mb-4">
							<div class="card border-left-warning shadow h-100 py-2">
								<div class="card-body">
									<div class="row no-gutters align-items-center">
										<div class="col mr-2">
											<div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
												Socios recientes (Año Actual)
											</div>
											<div class="h5 mb-0 font-weight-bold text-gray-800">
												{{ numEnabledMembers_current_year }}
											</div>
										</div>
										<div class="col-auto">
											<i class="fa-duotone fa-user-plus fa-2x text-gray-300"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-20-percent col-md-6 mb-4">
							<div class="card border-left-success shadow h-100 py-2">
								<div class="card-body">
									<div class="row no-gutters align-items-center">
										<div class="col mr-2">
											<div class="text-xs font-weight-bold text-success text-uppercase mb-1">
												Socios totales (activos)
											</div>
											<div class="h5 mb-0 font-weight-bold text-gray-800">
												{{ numEnabledMembers_total }}
											</div>
										</div>
										<div class="col-auto">
											<i class="fa-duotone fa-users fa-2x text-gray-300"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-20-percent col-md-6 mb-4">
							<div class="card border-left-danger shadow h-100 py-2">
								<div class="card-body">
									<div class="row no-gutters align-items-center">
										<div class="col mr-2">
											<div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
												Socios totales (inactivos)
											</div>
											<div class="h5 mb-0 font-weight-bold text-gray-800">
												{{ numNotEnabledMembers_total }}
											</div>
										</div>
										<div class="col-auto">
											<i class="fa-duotone fa-users-slash fa-2x text-gray-300"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-20-percent col-md-6 mb-4">
							<div class="card border-left-custom shadow h-100 py-2">
								<div class="card-body">
									<div class="row no-gutters align-items-center">
										<div class="col mr-2">
											<div class="text-xs font-weight-bold text-custom text-uppercase mb-1">
												Socios totales (pendientes)
											</div>
											<div class="h5 mb-0 font-weight-bold text-gray-800">
												{{ numPendingMembers_total }}
											</div>
										</div>
										<div class="col-auto">
											<i class="fa-duotone fa-user-clock fa-2x text-gray-300"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 d-flex flex-column align-items-end">
						<button
							type="button"
							class="btn btn-fbo mb-3"
							@click="generateFile()"
							:disabled="loadingData"
						>
							Descargar lista de Socios
						</button>

						<div class="d-flex align-items-center mb-3">
							<small class="text-muted me-2">
								Última sincronización del estado de socios y de reintento de pagos fallidos:
								<strong>{{ lastSyncTime ? lastSyncTime : 'N/A' }}</strong>
							</small>
							<button 
								class="btn btn-link text-muted p-0" 
								type="button" 
								data-bs-toggle="collapse" 
								data-bs-target="#syncInfoCollapse" 
								aria-expanded="false" 
								aria-controls="syncInfoCollapse"
							>
								<i class="fa-duotone fa-circle-info me-1"></i>
								<i class="fa-solid fa-chevron-down small"></i>
							</button>
							<button
								type="button"
								class="btn btn-pending btn-sm ms-2"
								@click="confirmSync()"
								:disabled="loadingData"
								title="Actualizar estado de socios"
							>
								<i class="fa-solid fa-rotate" :class="{ 'fa-spin': loadingData }"></i>
							</button>
						</div>
						<div class="collapse" id="syncInfoCollapse">
							<div class="text-end mt-2 mb-3">
								<div class="alert alert-light-warning py-2 px-3 border-0 shadow-sm" style="background-color: #fff4de; border-radius: 8px; display: inline-block;">
									<small class="text-warning-emphasis" style="font-size: 0.7rem;">
										<strong>Sincronización automática:</strong> Tras cada remesa, el sistema realiza 3 sincronizaciones de seguridad (1, 24 y 48 horas después) para actualizar el estado de los socios y hacer reintentos de los pagos fallidos de forma automática.
									</small>
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-5">
						<div class="card-body">
							<h6 class="font-weight-bold">Socios</h6>
							<div class="d-flex align-items-center mb-3">
								<div class="btn-group me-3" role="group">
									<button
										type="button"
										class="btn"
										:class="{
											'btn-success': filters.active,
											'btn-outline-success': !filters.active,
											'disabled-opacity': loadingData
										}"
										@click="toggleFilter('active')"
										:disabled="loadingData"
									>
										Activos
									</button>
									<button
										type="button"
										class="btn"
										:class="{
											'btn-danger': filters.inactive,
											'btn-outline-danger': !filters.inactive,
											'disabled-opacity': loadingData
										}"
										@click="toggleFilter('inactive')"
										:disabled="loadingData"
									>
										Inactivos
									</button>
									<button
										type="button"
										class="btn"
										:class="{
											'btn-custom-purple': filters.pending,
											'btn-outline-custom-purple': !filters.pending,
											'disabled-opacity': loadingData
										}"
										@click="toggleFilter('pending')"
										:disabled="loadingData"
									>
										Pendientes
									</button>
								</div>
								<div class="col-md-5 ms-auto px-0">
									<div class="row">
										<div class="input-group">
											<input
												class="form-control border-end-0 border"
												type="search"
												placeholder="Buscar..."
												id="example-search-input"
												v-model="searchValue"
												@keyup.enter="searchMembers"
											/>
											<span class="input-group-append">
												<button
													class="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border ms-n5"
													type="button"
													@click="searchMembers"
												>
													<i class="fa fa-search"></i>
												</button>
											</span>
										</div>
									</div>
								</div>
							</div>
							<div v-if="loadingData" class="text-center py-3">
								<div class="spinner-border text-primary" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
								<div class="mt-2">Cargando socios...</div>
							</div>
							<div v-else class="table-responsive">
								<EasyDataTable
									v-model:server-options="serverOptions"
									:loading="loadingData"
									:headers="headers"
									:items="items"
									:server-items-length="serverItemsLength"
								>
									<template
										#item-name="{ first_name, last_name }"
									>
										<div class="text-uppercase">
											{{ first_name + " " + last_name }}
										</div>
									</template>
									<template #item-region="{ region }">
										<div v-if="region">
											{{ region.name }}
										</div>
									</template>
									<template #item-enabled="{ enabled, pending }">
    <div class="text-center">
        <span
            v-if="!enabled"
            class="badge badge-light-danger"
        >Inactivo</span>

        <span
            v-else-if="pending"
            class="badge badge-light-info"
        >Pendiente</span>

        <span
            v-else
            class="badge badge-light-success"
        >Activo</span>
    </div>
</template>
									<template #item-quantity="{ quantity }">
										<div class="text-center">
											<span
												v-if="user_role == 'superadmin'"
												>{{
													formatCurrency(
														quantity / 100
													)
												}}
											</span>
											<span
												v-else
												style="filter: blur(4px)"
												>XXXX</span
											>
										</div>
									</template>
									<template
										#item-subscription="{ subscription }"
									>
										<div>
											<div
												v-if="
													subscription == 'monthly' &&
													user_role == 'superadmin'
												"
											>
												Mensual
											</div>
											<div
												v-else-if="
													subscription == 'annual' &&
													user_role == 'superadmin'
												"
											>
												Anual
											</div>
											<span
												v-else
												style="filter: blur(4px)"
												>XXXX</span
											>
										</div>
									</template>
									<template #item-createdAt="{ createdAt }">
										<div>
											{{ this.formatDate(createdAt) }}
										</div>
									</template>
									<template
										#item-num_members="{ num_members }"
									>
										<div>
											<span>{{ num_members }}</span>
										</div>
									</template>

									<template #item-action="{ UUID }">
										<div class="text-center">
											<router-link
												v-if="user_role == 'superadmin'"
												:to="
													'/membership/members/' +
													UUID
												"
												class="btn btn-sm btn-fbo"
												><i
													class="fa-regular fa-user"
												></i
											></router-link>
										</div>
									</template>
								</EasyDataTable>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="text-center py-5">
					<div class="spinner-border" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
					<div>Cargando información</div>
				</div>
			</div>
		</div>
	</div>
	<router-view></router-view>
</template>

<script>
// import mixin
import userRoles from "@/mixins/user-roles.js";
import NavbarMembership from "@/components/Layout/NavbarMembership.vue";
import ClipBoard from "@/components/Global/ClipBoard.vue";
import MembershipService from "@/services/membership.service.js";
import ComunidadService from "@/services/comunidad.service.js";
import RegionService from "@/services/region.service.js";
import CountryService from "@/services/country.service.js";
import UserService from "@/services/user.service.js";
import Swal from "sweetalert2";

export default {
	name: "MembersView",
	mixins: [userRoles],
	components: {
		NavbarMembership,
		ClipBoard,
	},
	computed: {
		currentUser() {
			return this.$store.state.auth.user;
		},
	},
	data() {
		return {
			loading: true,
			loadingData: true,
			lastSyncTime: null,
			user: null,
			members: null,
			newMember: {
				country: 66,
				subscription: "monthly",
				quantity: 2.75,
			},
			headers: [
				{ text: "Nombre", value: "name", sortable: true },
				{ text: "Nº socios", value: "num_members" },
				{ text: "Estado", value: "enabled", sortable: true },
				{ text: "Cantidad", value: "quantity", sortable: true },
				{ text: "Suscripción", value: "subscription", sortable: true },
				{ text: "Fecha de alta", value: "createdAt", sortable: true },
				{ text: "Provincia", value: "region", sortable: true },
				{ text: "", value: "action" },
			],
			items: [],

			searchValue: "",
			serverOptions: {
				page: 1,
				rowsPerPage: 25,
				sortBy: "createdAt",
				sortType: "desc",
			},
			serverItemsLength: 0,
			numEnabledMembers_current_month: 0,
			numEnabledMembers_current_year: 0,
			numEnabledMembers_total: 0,
			numNotEnabledMembers_total: 0,
			numPendingMembers_total: 0,
			filters: {
				active: true,
				inactive: true,
				pending: true,
			},
		};
	},
	watch: {
		serverOptions(value) {
			this.getMyMembers();
		},
	},
	methods: {
		async start() {
			this.loading = true;
			await this.getUser();
			await this.getMyMembers();

			this.loading = false;
		},

		async getUser() {
			this.user = await UserService.getLocalUser(this.teamUUID);
		},

		async getMyMembers() {
			this.loadingData = true;
			this.serverOptions.search = this.searchValue;
			this.serverOptions.filters = JSON.stringify(this.filters);

			try {
				var response = await MembershipService.getMyMembers(this.serverOptions);
				this.members = response.data.items;

				// CATCH THE SERVER TIMESTAMP HERE
				if (response.data.last_sync_from_server) {
					this.lastSyncTime = this.formatDate(response.data.last_sync_from_server);
				} else {
					this.lastSyncTime = null;
				}

				this.serverItemsLength = response.data.serverItemsLength;
				this.numEnabledMembers_current_month = response.data.numEnabledMembers_current_month;
				this.numEnabledMembers_current_year = response.data.numEnabledMembers_current_year;
				this.numEnabledMembers_total = response.data.numEnabledMembers_total;
				this.numNotEnabledMembers_total = response.data.numNotEnabledMembers_total;
				this.numPendingMembers_total = response.data.numPendingMembers_total;

				// Table content
				this.items = [];
				for (var i = 0; i < this.members.length; i++) {
					this.items.push({
						first_name: this.members[i].first_name,
						last_name: this.members[i].last_name,
						num_members: this.members[i].num_members,
						enabled: this.members[i].enabled,
						pending: this.members[i].pending,
						quantity: this.members[i].quantity,
						subscription: this.members[i].subscription,
						region: this.members[i].region,
						createdAt: this.members[i].createdAt,
						UUID: this.members[i].UUID,
					});
				}
			} catch (error) {
				console.error("Error fetching members:", error);
			} finally {
				this.loadingData = false;
			}
		},

		async generateFile() {
			this.loading = true;
			try{
				var response = await MembershipService.export_members_list();
				if(response.data){
					console.log('Response data: ', response.data);
					this.xlsx = response.data;
					console.log(this.xlsx, "xlsx");
				} else {
					console.error('Empty response data');
				}
			}catch (error){
				console.error('Error:', error);
			} finally {
				this.loading = false
			}
		},

		async confirmSync() {
			const result = await Swal.fire({
				title: '¿Sincronizar estados?',
				text: "Esta acción verificará los últimos pagos de todos los socios. Puede tardar unos segundos.",
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#7239ea', // Using your custom purple
				cancelButtonColor: '#6c757d',
				confirmButtonText: 'Sí, sincronizar ahora',
				cancelButtonText: 'Cancelar'
			});

			if (result.isConfirmed) {
				this.updatePendingStatus();
			}
		},

		async updatePendingStatus() {
			this.loadingData = true;
			try {
				const response = await MembershipService.updatePendingStatus();
				if (response.status === 200) {
					// Update local timestamp
					const now = new Date();
					this.lastSyncTime = this.formatDate(now);

					Swal.fire({
						position: "top-end",
						icon: "success",
						title: "Sincronización completada",
						showConfirmButton: false,
						timer: 1500,
						toast: true
					});
					
					await this.getMyMembers();
				}
			} catch (error) {
				console.error("Error:", error);
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'No se pudo completar la sincronización.',
				});
			} finally {
				this.loadingData = false;
			}
		},

		toggleFilter(filter) {
			if (!this.loadingData) {
				this.filters[filter] = !this.filters[filter];
				this.getMyMembers();
			}
		},

		padTo2Digits(num) {
			return num.toString().padStart(2, "0");
		},

		formatDate(d) {
			const date = new Date(d);
			return (
				[
					this.padTo2Digits(date.getDate()),
					this.padTo2Digits(date.getMonth() + 1),
					date.getFullYear(),
				].join("/") +
				" - " +
				[
					this.padTo2Digits(date.getHours()),
					this.padTo2Digits(date.getMinutes()),
				].join(":")
			);
		},

		formatCurrency(num) {
			const formatter = new Intl.NumberFormat("es-ES", {
				style: "currency",
				currency: "EUR",
			});
			return formatter.format(num);
		},

		searchMembers() {
            this.getMyMembers();
        },
	},
	created() {
		this.start();
	},
	mounted() {
		if (!this.currentUser) {
			this.$router.push("/login");
		}
	},
};
</script>

<style>
.col-xl-20-percent {
    flex: 0 0 20% !important;
    max-width: 20% !important;
}

.border-left-custom {
    border-left: 0.25rem solid #7239ea !important;
}

.text-custom {
    color: #7239ea !important;
}

.row.no-wrap {
    flex-wrap: nowrap !important;
}

.btn-pending {
	background-color: #7239ea !important;
	color: white !important;
}

.col-12.text-end {
	padding: 0;
}

/* Custom purple button styles */
.btn-custom-purple {
	background-color: #7239ea !important;
	color: white !important;
	border-color: #7239ea !important;
}

.btn-custom-purple:hover {
	background-color: #6333cc !important;
	border-color: #6333cc !important;
}

.btn-outline-custom-purple {
	color: #7239ea !important;
	border-color: #7239ea !important;
	background-color: white !important;
}

.disabled-opacity {
	opacity: 0.65 !important;
	cursor: not-allowed !important;
}

/* Loading spinner style */
.spinner-border.text-primary {
	width: 2rem;
	height: 2rem;
}

.btn-outline-success {
	color: #28a745 !important;
	border-color: #28a745 !important;
	background-color: white !important;
}

.btn-outline-danger {
	color: #dc3545 !important;
	border-color: #dc3545 !important;
	background-color: white !important;
}

/* Ensure the sync button is a nice square/circle shape */
.btn-pending.btn-sm {
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}

/* Adjust the text alignment for the last sync message */
.text-muted.small {
    font-size: 0.85rem;
}

/* When the collapse is closed (arrow down) */
.btn-link .fa-chevron-down {
    transition: transform 0.3s ease;
}

/* When the collapse is open (rotate to arrow up) */
.btn-link[aria-expanded="true"] .fa-chevron-down {
    transform: rotate(180deg);
}
</style>
